// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vot1","right":"styles_right__36mix"};